import { useFamily } from '@/context/FamilyContext'
import { FamilySetupRequired } from './FamilySetupRequired'

interface RequireFamilyProps {
  children: React.ReactNode
}

/**
 * Wrapper that shows FamilySetupRequired screen if user has no family record.
 * Should be used after RequireAuth to ensure user is authenticated first.
 */
export function RequireFamily({ children }: RequireFamilyProps) {
  const { needsFamilySetup, isLoading } = useFamily()

  // Show nothing while loading family data
  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[var(--color-kids-bg)]">
        <div className="text-center">
          <div className="w-12 h-12 border-4 border-[var(--color-kids-primary)] border-t-transparent rounded-full animate-spin mx-auto mb-4" />
          <p className="text-[var(--color-kids-text-muted)]">Loading...</p>
        </div>
      </div>
    )
  }

  // If user needs family setup, show the setup required screen
  if (needsFamilySetup) {
    return <FamilySetupRequired />
  }

  return <>{children}</>
}
